import { deserializeHTMLString, serializeSlateValue } from "./utilities/slateSerialize";
import { SlateRTE as Slate } from "./SlateRTE";
export const SlateRTE = Object.assign(Slate, { serialize: serializeSlateValue, deserialize: deserializeHTMLString });
